import { Box, Button } from '@elkaso-app/web-design';
import { getFamilyPriceMatrixEndpointIdentifier } from 'apis/exclusive-deals/use-get-family-price-matrix-api';
import type { MasterProduct } from 'apis/master-products';
import { InlineVariantForm } from 'pages/inquiry-processor/components/item-board/inline-variant-form';
import { useQueryClient } from 'react-query';

export interface AddVariantControlProps {
  familyId: number;
  familyName: string;
  isOpen: boolean;
  onOpen: () => void;
  onCancel: () => void;
  // Fires after the matrix refetch has been queued, with the created variant.
  onCreated: (product: MasterProduct) => void;
}

// "+ Add variant" under the matrix: a dashed trigger that expands into the
// same inline variant form Match Maker uses, so a missing SKU gets created
// without leaving the price tool. Creating invalidates the family-matrix
// read model — the new row appears on refetch (the caller pins it past the
// view filters, since it has no price yet to match on).
export const AddVariantControl = ({
  familyId,
  familyName,
  isOpen,
  onOpen,
  onCancel,
  onCreated,
}: AddVariantControlProps) => {
  const queryClient = useQueryClient();

  if (!isOpen) {
    return (
      <Button
        variant='outline'
        size='sm'
        fontSize='13px'
        fontWeight='medium'
        color='gray.600'
        borderStyle='dashed'
        borderColor='gray.300'
        borderRadius='9px'
        bg='white'
        onClick={onOpen}>
        + Add variant
      </Button>
    );
  }

  return (
    <Box maxW='960px'>
      <InlineVariantForm
        familyId={familyId}
        familyName={familyName}
        initialValues={{}}
        onCancel={onCancel}
        onCreated={(product) => {
          queryClient.invalidateQueries([getFamilyPriceMatrixEndpointIdentifier, familyId]);
          onCreated(product);
        }}
      />
    </Box>
  );
};
